<template>
  <div class="form-single-fragment" style="position: relative;">
<!--    <el-form ref="activityFormFilter" :model="activityForm" :size="defaultFormItemSize"-->
<!--      label-width="100px" label-position="right" @submit.native.prevent-->
<!--    >-->
<!--      <filter-box :item-width="350"-->
<!--        @search="refreshActivityForm(true)"-->
<!--        @reset="onResetActivityForm"-->
<!--      >-->
<!--      </filter-box>-->
<!--    </el-form>-->
    <el-form ref="activityForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="参与人数" prop="Activity.participants">
            <el-select class="input-item" v-model="formData.Activity.participants" :clearable="true" filterable
              placeholder="参与人数" :loading="activityForm.participants.impl.loading"
              @visible-change="activityForm.participants.impl.onVisibleChange"
              @change="onParticipantsValueChange">
              <el-option v-for="item in activityForm.participants.impl.dropdownList" :key="item.id"
                :value="item.id" :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="成效" prop="Activity.effect">
            <el-input class="input-item" v-model="formData.Activity.effect"
              :clearable="true" placeholder="成效"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="活动内容(50字以上)" prop="Activity.activityContent">
            <el-input  type="textarea"   :rows="2" class="input-item" v-model="formData.Activity.activityContent"
              :clearable="true" placeholder="活动内容(50字以上)" minlength="50" show-word-limit
            />
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="附件" prop="Activity.attachedFiles">-->
<!--            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--              :action="getUploadActionUrl('/admin/app/activity/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              :limit="activityForm.attachedFiles.impl.maxCount"-->
<!--              :file-list="activityForm.attachedFiles.impl.fileList"-->
<!--              :show-file-list="true">-->
<!--              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <el-col :span="12" v-show="true">
          <el-form-item label="附件" prop="Activity.attachedFiles">
            <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                       :action="getUploadActionUrl('/admin/app/activity/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: false}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :on-error="onUploadError" :on-exceed="onUploadLimit"
                       :limit="activityForm.attachedFiles.impl.maxCount"
                       :file-list="activityForm.attachedFiles.impl.fileList"
                       :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="activityForm.attachedFiles.impl.fileList && activityForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in activityForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="!readOnly"
                             @click="deleteAttachedFiles(item,activityForm.attachedFiles.impl.fileList,index)">删除
                  </el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in activityForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>

<!--        <el-col :span="12">-->
<!--          <el-form-item label="现场图片" prop="Activity.siteImages">-->
<!--            <el-upload-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/activity/upload')"-->
<!--              :data="{fieldName: 'siteImages', asImage: true}"-->
<!--              :on-success="onSiteImagesUploadSuccess"-->
<!--              :on-remove="onSiteImagesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->

<!--              :show-file-list="false">-->
<!--              <div v-if="activityForm.siteImages.impl.fileList && activityForm.siteImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="activityForm.siteImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSiteImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

        <el-col :span="12">
          <el-form-item label="现场图片" prop="Activity.siteImages">
            <el-upload
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/activity/upload')"
                       :data="{fieldName: 'siteImages', asImage: true}"
                       :on-success="onSiteImagesUploadSuccess"
                       :on-remove="onSiteImagesRemoveFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="activityForm.siteImages.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="activityForm.siteImages.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"
                       @click="onAddClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ActivityController, DictionaryController } from '@/api';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'activityForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        Activity: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          activityContent: undefined,
          effect: undefined,
          participants: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'Activity.siteImages': [
          {required: true, message: '请输入现场图片', trigger: 'blur'}
        ],
        'Activity.activityContent': [
          {required: true, message: '请输入活动内容', trigger: 'blur'}
        ],
        'Activity.participants': [
          {required: true, message: '请输入参与人数', trigger: 'blur'}
        ]
      },
      activityForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        participants: {
          impl: new DropdownWidget(this.loadParticipantsDropdownList)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        siteImages: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 参与人数下拉数据获取函数
     */
    loadParticipantsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictParticipantsNumber(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 参与人数选中值改变
     */
    onParticipantsValueChange (value) {
    },
    /**
     * 更新活动表单
     */
    refreshActivityForm (reloadData = false) {
      this.loadActivityData().then(res => {
        if (!this.activityForm.isInit) {
          // 初始化下拉数据
        }
        this.activityForm.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.activityForm.validate((valid) => {
        if (!valid) return;
        let activityContent = this.formData.Activity.activityContent
        if (activityContent.length < 50) {
          this.$message.error('活动内容50字以上')
          return
        }
        let params = {
          activityDto: {
            // id: this.formData.Activity.activityContent,
            // activityContent: this.formData.Activity.activityContent,
            // effect: this.formData.Activity.effect,
            // participants: this.formData.Activity.participants,
            // siteImages: this.formData.Activity.siteImages,
            // attachedFiles: this.formData.Activity.attachedFiles
            ...this.formData.Activity
          }
        };
        if (params.activityDto.id) {
          ActivityController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          ActivityController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    onResume () {
      this.refreshActivityForm(true);
    },
    /**
     * 获取活动详细信息
     */
    loadActivityData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.Activity.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          ActivityController.view(this, params).then(res => {
            this.formData.Activity = {...res.data, isDatasourceInit: true};
            if (this.formData.Activity.participantsDictMap && this.activityForm.participants.impl.dirty) {
              this.activityForm.participants.impl.dropdownList = [this.formData.Activity.participantsDictMap];
            }
            let attachedFilesDownloadParams = {
              id: this.formData.Activity.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.activityForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.Activity.attachedFiles, attachedFilesDownloadParams);
            let siteImagesDownloadParams = {
              id: this.formData.Activity.id,
              fieldName: 'siteImages',
              asImage: true
            }
            this.activityForm.siteImages.impl.fileList = this.parseUploadData(this.formData.Activity.siteImages, siteImagesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.Activity.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.activityForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.Activity.attachedFiles = this.fileListToJson(this.activityForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onAttachedFilesRemoveFile (file, fileList) {
      this.activityForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.Activity.attachedFiles = this.fileListToJson(this.activityForm.attachedFiles.impl.fileList);
    },
    /**
     * 现场图片上传成功
     */
    onSiteImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.activityForm.siteImages.impl.onFileChange(file, fileList);
        this.formData.Activity.siteImages = this.fileListToJson(this.activityForm.siteImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除现场图片
     */
    onSiteImagesRemoveFile (file, fileList) {
      this.activityForm.siteImages.impl.onFileChange(file, fileList);
      this.formData.Activity.siteImages = this.fileListToJson(this.activityForm.siteImages.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        Activity: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          activityContent: undefined,
          effect: undefined,
          participants: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshActivityForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
